import React from 'react';

function MinusSign() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="8"
      viewBox="0 0 8 8"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="#CFDEB7">
          <path d="M0 5.33333333L1.2246468e-16 3 8 3 8 5.33333333z" />
        </g>
      </g>
    </svg>
  );
}

export default MinusSign;
